import * as jsxRuntime from "C:\\Eidos!!!\\banehaverne3.0\\86-eido-banehaverne-3.0\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment